import classes from './LoadingSpinner.module.css';
const LoadingSpinner = () => {
  return <div className={classes.loader}></div>;
};

export default LoadingSpinner;
